import React from 'react';
import { InverterSelectorForm } from './components/InverterSelectorForm';
import './App.css'; 
import { CssBaseline } from '@mui/material';
import Container from '@mui/material/Container';

const App = () => {

  
  return (
    <React.Fragment>  
      <CssBaseline>   
      <Container maxWidth="xs" className='App'>
          <InverterSelectorForm />
      </Container>
      </CssBaseline>
    </React.Fragment>
  );
}



export default App;
